// Provides function for the industry selection section of the home page

(function () { // eslint-disable-line
  var $itemClassName = '.industries__link';
  var $itemClassNameActive = 'industries__link--active';
  var $panelClassName = '.industry';
  var $panelClassNameActive = 'industry--active';

  function IndustrySelector(elementID) {
    var self = this;
    this.$element = document.getElementById(elementID);
    this.$itemList = this.$element.querySelectorAll($itemClassName);
    this.$panelList = this.$element.querySelectorAll($panelClassName);
    this.checkSupport();
    this.registerEventToArray(this.$itemList, 'click', function (event) {
      self.handleItemClick(event);
    });
  }

  IndustrySelector.prototype.checkSupport = function () {
    var support = false;
    if ('CSS' in window && 'supports' in window.CSS) {
      support = window.CSS.supports('background-blend-mode', 'soft-light');
    }
    support = support ? 'background-blend-mode' : 'no-background-blend-mode';
    this.addClass(this.$element, support);
  };

  // Registers an event to an array of elements
  IndustrySelector.prototype.registerEventToArray = function (list, type, handler) {
    var i;
    for (i = 0; i < list.length; i += 1) {
      this.registerEvent(list[i], type, handler);
    }
  };

  // Registers an event to a single element
  IndustrySelector.prototype.registerEvent = function (element, type, handler) {
    if (element.attachEvent) {
      element.attachEvent('on' + type, handler);
    } else {
      element.addEventListener(type, handler);
    }
  };

  // Handles the click of an item
  IndustrySelector.prototype.handleItemClick = function (event) {
    var $target;
    event.preventDefault();
    $target = event.target;

    // Selector List
    this.removeAll(this.$itemList, $itemClassNameActive);
    this.addClass(
      $target,
      $itemClassNameActive
    );

    // Panel List
    this.removeAll(this.$panelList, $panelClassNameActive);
    this.addClass(
      document.getElementById($target.getAttribute('data-id')),
      $panelClassNameActive
    );

    this.updateBackground(
      $target.getAttribute('data-colour'),
      $target.getAttribute('data-bg-path')
    );
    this.updateStyles($target.getAttribute('data-colour'));
  };


  // Adds a class to an element
  IndustrySelector.prototype.addClass = function (element, className) {
    if (element.classList) {
      element.classList.add(className);
    } else if (!this.hasClass(element, className)) {
      element.className += ' ' + className;  // eslint-disable-line
    }
  };

  // Removes a class from an element
  IndustrySelector.prototype.removeClass = function (element, className) {
    if (element.classList) {
      element.classList.remove(className);
    } else {
      element.className = element.className.replace(  // eslint-disable-line
        new RegExp('\\b' + className + '\\b', 'g'),
        ''
      );
    }
  };

  // Checks if an element has a class
  IndustrySelector.prototype.hasClass = function (element, className) {
    var hasClass;
    if (element.classList) {
      hasClass = element.classList.contains(className);
    } else {
      hasClass = new RegExp('\\b' + className + '\\b').test(element.className);
    }
    return hasClass;
  };

  // Removes a class from a list of elements
  IndustrySelector.prototype.removeAll = function (list, className) {
    var i;
    for (i = 0; i < list.length; i += 1) {
      this.removeClass(list[i], className);
    }
  };

  // Updates the background image and background colour
  IndustrySelector.prototype.updateBackground = function (color, image) {
    this.$element.style.backgroundColor = '#' + color;
    this.$element.style.backgroundImage = 'url(' + image + ')';
  };

  // Appends a stylesheet that will color the hover states of the links with the current color
  IndustrySelector.prototype.updateStyles = function (color) {
    var style = document.createElement('style');
    var cssText = '.industries-section ' + $itemClassName + ':hover , \n';
    cssText += '.industries-section ' + $itemClassName + ':active , \n';
    cssText += '.industries-section ' + $itemClassName + ':focus \n';
    cssText += ' { color: #' + color + ' } \n';
    cssText += '.industries-section .industries::before { background-color: #' + color + ' }';
    if (style.styleSheet) {
      style.styleSheet.cssText = cssText;
    } else {
      style.appendChild(document.createTextNode(cssText));
    }
    if (this.$element.querySelector('.industries > style')) {
      this.$element.removeChild(this.$element.querySelector('.industries > style'));
    }
    this.$element.appendChild(style);
  };

  var IndustrySelector = new IndustrySelector('industries');
  $('.industry').matchHeight({ byRow: false });
}());
